import { copyByJson } from '@src/utils'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    items: (state) => state.items || [],
  },
  mutations: {
    addItem(state, view) {
      let pathCheck = view.path
      if (pathCheck[pathCheck.length - 1] === '/') {
        pathCheck = pathCheck.slice(0, -1)
      }
      view.path = pathCheck
      if (
        view.name == 'redirect' ||
        state.items.some((v) => v.path === view.path)
      ) {
        return
      }
      state.items.push(Object.freeze(view))
    },
    removeItem(state, index) {
      state.items.splice(index, 1)
    },
    removeAllItem(state) {
      state.items = []
    },
    removeOther(state, index) {
      state.items = state.items.splice(index, 1)
    },
    removeToRight(state, index) {
      state.items = state.items.splice(0, index)
    },
  },
  actions: {},
}
